

























































import ClaimContentTop from '@/components/common/claim/ClaimContentTop.vue'
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/claim/grid/ItemTable.vue'
import { Component, Mixins, Ref } from 'vue-property-decorator';
import LayerPopup from '@/components/LayerPopup.vue';
import ClaimGrid from '@/components/claim/mixins/ClaimGrid';
import {i18nInObjectList} from '@/utils/i18n';
import {ClaimType} from '@/types/claim';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import { GridNameType } from 'ncp-api-supporter';

@Component({
  components: {
    ClaimContentTop,
    PageTitle,
    LayerPopup,
    ItemTable,
    ExcelCreateButton
  }
})
export default class CancelList extends Mixins(ClaimGrid, OrderGridBrokenFreeGiftMixin) {
  @Ref()
  private readonly gridRef: ItemTable;

  private request: any = {
    params: {}
  };
  private excelRequest: any = {
    params: {}
  };
  private listCount = 0;
  private gridProps = {
    columns: [],
    options: {
      columnOptions: {
        minWidth: 50,
        resizable: true,
      },
      pageOptions: {
        page: 1,
        perPage: 30,
        centerAlign: true
      },
      rowHeight: 32,
      minRowHeight: 32,
      minBodyHeight: 192,
    }
  }
  // TODO: 엑셀 공통화
  private contentBottomOption = {
    gridName: 'CLAIM_CANCEL_GRID',
    showTopcontent: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: false,
    haveConfigBtn: true,
    haveDataBodyHeight: 480,
    onLoadSearch: false,
    excelDownInfo: {},
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      },
    ],
  };
  private result = {
    contents: [],
    totalCount: 0
  }

  // page와 perpage를 searchForm과 grid가 서로 공유해야하므로 search 요청은 부모 컴포넌트에서 시행한다.
  // TODO: 로직이 각 페이지별로 반복 됨.
  private async onSearchResult(request: any){
    this.request = {params: {...request}}
    this.excelRequest = {params: {...request, size: null}}
    this.gridProps.options.pageOptions.page = Number(request.page);

    const {data} = await this.$api.getClaims({
      params: {
        ...request,
        size: this.gridProps.options.pageOptions.perPage
      }
    })

    let serializedData = {
      contents: [],
      totalCount: data.totalCount
    }
    if (data.contents.length > 0) {
      this.listCount = data.contents.length
      serializedData.contents = [...this.claimFormatterList(data.contents, 'options')];

      const bigRow = [
        'mallName',
        'claimYmdt',
        'claimCompleteYmdt',
        'invoiceNo',
        'procEachBtn',
        'claimStatusType',
        'claimNo',
        'mallNo',
        'orderRegisterType',
        'reserved',
        'payType',
        'shippingAreaType',
        'memberGroupInfoJson',
        'orderNo',
        'ordererName',
        'ordererContact1',
        'memberNo',
        'receiverName',
        'receiverContact1',
        'claimAmt',
        'partnerNo'
      ];
      serializedData.contents = [...this.claimMeargeRow(serializedData.contents, bigRow, 'claimNo')];
    }

    this.result.contents = serializedData.contents
    this.result.totalCount = serializedData.totalCount
  }

  changePerPage(page:number, perPage:number = this.gridProps.options.pageOptions.perPage): void{
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = perPage;
    (this.$refs.ClaimContentTop as any).onSearch(page.toString());
  }

  created(){
    this.initGridProps()
    this.initExelDownloadInfo()
  }

  private initGridProps(){
    this.gridProps.columns = this.getClaimColumns(ClaimType.CANCEL)
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }

  private async initExelDownloadInfo(){
    this.contentBottomOption.excelDownInfo = await this.getExcelDownInfo(ClaimType.CANCEL, this.contentBottomOption.gridName as GridNameType)
  }
}
